import { Building } from "../../../building/Building";
import { WallContainer } from "../../../building/wall/WallContainer";
import { MaterialManager } from "../../../material/MaterialManager";
import { BoxGeometry } from "three";
import { WallAddon } from "../../addon/WallAddon";
import { ISceneAddon } from "../../addon/ISceneAddon";

export class WainscotTrim
{

	private static THICKNESS = 0.05;
	private static HEIGHT    = 0.3;

	private _building : Building;

	private _wallContainer : WallContainer;

	/*
	// original
	private _left_original  : THREE.Mesh;
	private _right_original : THREE.Mesh;
	private _front_original : THREE.Mesh;
	private _back_original  : THREE.Mesh;

	// current
	private _left  : THREE.Mesh;
	private _right : THREE.Mesh;
	private _front : THREE.Mesh;
	private _back  : THREE.Mesh;
	*/

	constructor(building:Building)
	{
		this._building = building;
		this.init();
	}

	private init()
	{
		var geometry = new BoxGeometry();
		var material = MaterialManager.getInstance().trim;

		// sideGeometry and endGeometry can be the same as UV's don't matter (not texture for trim)
		this._wallContainer = new WallContainer({
			sideGeometry: geometry,
			endGeometryFront: geometry,
			endGeometryBack: geometry,
			material: material,
			setRotations: false
		});

		var left  = this._wallContainer.left.original;
		var right = this._wallContainer.right.original;
		var front = this._wallContainer.front.original;
		var back  = this._wallContainer.back.original;

		left.scale.x  =
		right.scale.x =
		front.scale.z =
		back.scale.z  = WainscotTrim.THICKNESS;

		left.scale.y  =
		right.scale.y =
		front.scale.y =
		back.scale.y  = WainscotTrim.HEIGHT;

		var scene = this._building.scene3D;
		this._wallContainer.add(scene);

		/*
		this._left  = new THREE.Mesh(geometry, material);
		this._right = new THREE.Mesh(geometry, material);
		this._front = new THREE.Mesh(geometry, material);
		this._back  = new THREE.Mesh(geometry, material);

		var parent = this._building.scene3D;
		parent.add(this._left);
		parent.add(this._right);
		parent.add(this._front);
		parent.add(this._back);

		this._left.scale.x  =
		this._right.scale.x =
		this._front.scale.z =
		this._back.scale.z  = WainscotTrim.THICKNESS;

		this._left.scale.y  =
		this._right.scale.y =
		this._front.scale.y =
		this._back.scale.y  = WainscotTrim.HEIGHT;

		this._left_original  = this._left;
		this._right_original = this._right;
		this._front_original = this._front;
		this._back_original  = this._back;
		*/

		var buildingConfig = this._building.config.building;
		var wainscot = buildingConfig.wainscot;
		//wainscot.signal.add(this.onWainscotChange);

		if (!wainscot.value)
		{
			this.hide();
		}
	}

	// TODO delete, Wainscot.onWainscotChange takes care of this
	//private onWainscotChange = () =>
	//{
	//	// assumes wainscot size doesn't change just the state (on > 0, off = 0)
	//
	//	var wainscot = this._building.config.building.wainscot;
	//	var no_walls = this._building.config.building.no_walls.value;
	//
	//	var value = wainscot.value;
	//
	//	// see Wainscot.onWainscotChange
	//	if (no_walls)
	//	{
	//		value = 0;
	//	}
	//
	//	if (value > 0)
	//	{
	//		// show wainscot
	//		this.show();
	//		this.updateSize();
	//	}
	//	else
	//	{
	//		this.hide();
	//	}
	//};

	public updateSize()
	{
		// called when the building size changes

		var metrics = this._building.config.metrics;
		var wainscotValue = this._building.config.building.wainscot.value;

		// length should be shorter than full, so it doesn't collide
		var length_diff = 0.2;

		var left  = this._wallContainer.left.original;
		var right = this._wallContainer.right.original;
		var front = this._wallContainer.front.original;
		var back  = this._wallContainer.back.original;

		right.position.x = metrics.width_half + WainscotTrim.THICKNESS/2 + 0.01;
		right.position.y = wainscotValue;
		right.scale.z    = metrics.length - length_diff;

		left.position.x  = - (metrics.width_half + WainscotTrim.THICKNESS/2 + 0.01);
		left.position.y  = wainscotValue;
		left.scale.z     = metrics.length - length_diff;

		front.position.z = metrics.length_half + WainscotTrim.THICKNESS/2 + 0.01;
		front.position.y = wainscotValue;
		front.scale.x    = metrics.width - length_diff;

		back.position.z  = - (metrics.length_half + WainscotTrim.THICKNESS/2 + 0.01);
		back.position.y  = wainscotValue;
		back.scale.x     = metrics.width - length_diff;
	}

	public hide()
	{
		this._wallContainer.hide();
	}

	public show()
	{
		this._wallContainer.show();
	}

	public addNode(node:WallAddon)
	{
		this._wallContainer.addNode(node, false);
	}

	public updateCuts(addons:{[wallId:string]:ISceneAddon[]})
	{
		this._wallContainer.updateCuts(addons, false);
	}
}